<template>
    <div class="o-qr-code-generator qr-code-generator" ref="qr" />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import qrcode from 'qrcode-generator';

export default {
    name: 'OQrGenerator',
    computed: {
        ...mapState({
            mapId: state => state.map.id
        }),
        ...mapGetters([
            'getObject',
            'getTerminalId',
        ]),
        itemId() {
            return parseInt(this.$route.params.id, 10);
        },
        item() {
            return this.getObject(this.itemId);
        },
        type() {
            return this.item.type === 'tenant' ? 'care' : 'service';
        }
    },
    async mounted() {
        this.generateCode();
    },
    methods: {
        generateCode() {
            const typeNumber = 0;
            const errorCorrectionLevel = 'L';
            const from =  this.getTerminalId || this.$route.query.from || '';
            const qr = qrcode(typeNumber, errorCorrectionLevel);
            qr.addData(location.origin + '/' + `map-${this.mapId}/mobile/guide/${this.type}?to=${this.itemId}&from=${from}&redirect-from=qr`);
            qr.make();
            this.$refs.qr.innerHTML = qr.createSvgTag({ margin: 0});

        }
    }
}
</script>

<style lang="scss">
@import "o-qr-code-generator";
</style>
